import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiProgressModule } from "@taiga-ui/kit";
import { KwikUIProgressBarComponent } from "./progress-bar.component";

@NgModule({
  declarations: [KwikUIProgressBarComponent],
  imports: [CommonModule, TuiProgressModule],
  exports: [KwikUIProgressBarComponent]
})
export class KwikUIProgressBarModule {}
